<template>
  <div class="wrapper" :class="{'sidebar-shown': displaySidebar, 'sidebar-open': sidebarOpen}">
    <sidebar active="2" @openSidebar="sidebarOpen = true" @closeSidebar="sidebarOpen = false" @saveProgress="showSaveProgress = true"/>
    <main id="main" class="content has-sidebar">
      <app-header :back="back"></app-header>
      <header class="page">
        <h1 class="title">Goals</h1>
        <p class="subtitle">What are your priorities?</p>
      </header>
      <form class="form">
        <div class="form-row">
          <label class="form-label">Primary Goal</label>
          <drop-down :items="goals" :selected="primaryGoal" @changed="handleSelection('primary',$event)"></drop-down>
        </div>
        <div class="form-row">
          <label class="form-label">Secondary Goal</label>
          <drop-down :items="goals" :selected="secondaryGoal" @changed="handleSelection('secondary',$event)"></drop-down>
        </div>
        <div class="form-row">
          <button class="btn btn-primary has-arrow" @click.prevent="$router.push({ name: 'species' })">Next</button>
        </div>
      </form>
    </main>
    <save-progress :shown="showSaveProgress" @close="showSaveProgress = false" />
  </div>
</template>

<script>
import Sidebar from '@/components/Sidebar'
import Header from '@/components/Header'
import Dropdown from '@/components/Dropdown'
import SaveProgress from '@/components/SaveProgress'
export default {
  components: {
    'sidebar': Sidebar,
    'drop-down': Dropdown,
    'app-header': Header,
    'save-progress': SaveProgress
  },
  data () {
    return {
      back: 'planting-time',
      displaySidebar: true,
      sidebarOpen: false,
      showSaveProgress: false,
      goals: [
        'Supplemental Grazing',
        'Build Residue/Soil Armor',
        'Reduce Soil Compaction',
        'Nitrogen Fixation',
        'Nutrient Scavenging',
        'Growth in Saline Soils',
        'Mineralize Residue/Cycle Nutrients'
      ]
    }
  },
  methods: {
    handleSelection (which, value) {
      if (which === 'primary') {
        if (value !== this.$store.state.formData.primaryGoal) {
          this.$emit('resetCrops')
        }
        this.primaryGoal = value
      } else {
        if (value !== this.$store.state.formData.secondaryGoal) {
          this.$emit('resetCrops')
        }
        this.secondaryGoal = value
      }
    }
  },
  computed: {
    primaryGoal: {
      get () {
        return this.goals[this.$store.state.formData.primaryGoal]
      },
      set (value) {
        this.$store.commit('updatePrimaryGoal', value)
      }
    },
    secondaryGoal: {
      get () {
        return this.goals[this.$store.state.formData.secondaryGoal]
      },
      set (value) {
        this.$store.commit('updateSecondaryGoal', value)
      }
    }
  }
}
</script>

<style lang="scss">

</style>
